import { useMemo } from 'react';
import { completedDates } from '../content/sessions';
import { currentStreak, weekDoneIndexes } from '../domain/exercise';
import { useCountedSessions } from './use-marks';
import { todayIso } from './use-today';

/** Days the routine was completed on, plus what Home derives from them. */
export interface Progress {
  /** ISO dates (YYYY-MM-DD) on which all three exercises were done. */
  completedDates: string[];
  /** Consecutive days up to today (or yesterday while today is unfinished). */
  streak: number;
  /** Monday → Sunday indexes done this week — the streak card's filled circles. */
  doneIndexes: number[];
  /** Exercises ever completed, whole days or not — zero means the welcome card is still due. */
  exercisesDone: number;
}

/** Completed-day history derived from the participant's sessions in Core, marks included. */
export function useProgress() {
  const sessions = useCountedSessions();
  const today = todayIso();
  const data = useMemo((): Progress | undefined => {
    if (!sessions.data) return undefined;
    const dates = completedDates(sessions.data);
    let exercisesDone = 0;
    for (const session of sessions.data) {
      for (const attempt of session.attempts)
        if (attempt.value.state === 'done') exercisesDone += 1;
    }
    return {
      completedDates: dates,
      streak: currentStreak(dates, today),
      doneIndexes: weekDoneIndexes(dates, today),
      exercisesDone,
    };
  }, [sessions.data, today]);
  return { data, isLoading: sessions.isLoading, error: sessions.error };
}
